import Icons from "../../assets/icons/index.js";
import { AiOutlineClose } from "react-icons/ai";
import {
  Btn,
  InputField,
  FormHeading,
  AuthLayout,
  Loader,
  Text,
} from "../../components/index";
import registerFunction from "./index.function.js";
import { fontSizes } from "../../constants/constants.js";
export default function RegisterScreen() {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    errors,
    loadingToapi,
    handleContinueClick,
    closePopup,
    showPopup,
    onSubmit,
    selectedUserType,
    navigate,
    TextWeight,
  } = registerFunction();
  return (
    <AuthLayout isBackBnt={true} isPath={"/selectUserType"}>
      <FormHeading
        title="Get Yourself"
        highlightText={"Register"}
        description={
          "Create your account by filling out the registration form below to access exclusive features, personalized recommendations, and project management tools."
        }
      />
      <form className="px-2" onSubmit={handleSubmit(onSubmit)}>
        <div className="relative mt-2.5 2xl:mt-5 ">
          <InputField
            type="text"
            name="fullname"
            placeholder="Full name"
            {...register("fullname", { required: "Full Name is required" })} // This registers the input with react-hook-form
            onChange={(value) => setValue("fullname", value)} // Pass the value to setValue
            icon={Icons.Userinputicons}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
          {errors.fullname && (
            <span style={{ color: "red" }}>{errors.fullname.message}</span>
          )}
        </div>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            name="text"
            placeholder="Email Address"
            {...register("email", {
              required: "Email is required",
              // pattern: {
              //     value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
              //     message:
              //         'Please enter a valid email address',
              // },
            })}
            onChange={(value) => setValue("email", value)}
            icon={Icons.EmailIcons}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
          />
          {errors.email && (
            <span style={{ color: "red" }}>{errors.email.message}</span>
          )}
        </div>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="text"
            name="Phone Number"
            placeholder="Phone Number"
            {...register("phone", { required: "Phone Number is required" })}
            onChange={(value) => setValue("phone", value)}
            icon={Icons.ClliIcons}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-7 2xl:h-6"}
          />
          {errors.phone && (
            <span style={{ color: "red" }}>{errors.phone.message}</span>
          )}
        </div>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="password"
            name="password"
            placeholder="Password"
            {...register("password", {
              required: "Password is required",
              // pattern: {
              //     value: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,16}$/,
              //     message:
              //         "Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.",
              // },
            })}
            onChange={(value) => setValue("password", value)}
            isPassword={true}
            icon={Icons.lockIcons}
            iconPasswordVisible={Icons.showPasswordIcon}
            iconPasswordHidden={Icons.hidePasswordIcon}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
          {errors.password && (
            <span style={{ color: "red" }}>{errors.password.message}</span>
          )}
        </div>
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            {...register("confirmPassword", {
              required: "Confirm Password is required",
              validate: (value) =>
                value === getValues("password") || "Passwords do not match",
            })}
            onChange={(value) => setValue("confirmPassword", value)}
            isPassword={true}
            icon={Icons.lockIcons}
            iconPasswordVisible={Icons.showPasswordIcon}
            iconPasswordHidden={Icons.hidePasswordIcon}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"}
          />
          {errors.confirmPassword && (
            <span style={{ color: "red" }}>
              {errors.confirmPassword.message}
            </span>
          )}
        </div>
        <div className="mt-2.5 2xl:mt-5 flex flex-col sm:flex-row">
          {selectedUserType === "student" ? (
            <>
              <div className="w-full sm:w-1/2 relative pr-0 sm:pr-1 lg:pr-2">
                <InputField
                  type="text"
                  name="collegeAddress"
                  placeholder="College Address"
                  {...register("collegeAddress", {
                    required: "College Address is required",
                  })}
                  onChange={(value) => setValue("collegeAddress", value)}
                  icon={Icons.lcationIon}
                  iconStyle="w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"
                />
                {errors.collegeAddress && (
                  <span style={{ color: "red" }}>
                    {errors.collegeAddress.message}
                  </span>
                )}
              </div>
              <div className="w-full sm:w-1/2 relative pl-0 sm:pl-1 lg:pl-2 mt-4 sm:mt-0">
                <InputField
                  type="text"
                  name="collegeName"
                  placeholder="College Name"
                  {...register("collegeName", {
                    required: "College Name is required",
                  })}
                  onChange={(value) => setValue("collegeName", value)}
                  icon={Icons.companyName}
                  iconStyle="w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"
                />
                {errors.collegeName && (
                  <span style={{ color: "red" }}>
                    {errors.collegeName.message}
                  </span>
                )}
              </div>
            </>
          ) : (
            <>
              <div className="w-full sm:w-1/2 relative pr-0 sm:pr-1 lg:pr-2">
                <InputField
                  type="text"
                  name="companyAddress"
                  placeholder="Company Address"
                  {...register("companyAddress", {
                    required: "Company Address is required",
                  })}
                  onChange={(value) => setValue("companyAddress", value)}
                  icon={Icons.lcationIon}
                  iconStyle="w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"
                />
                {errors.companyAddress && (
                  <span style={{ color: "red" }}>
                    {errors.companyAddress.message}
                  </span>
                )}
              </div>
              <div className="w-full sm:w-1/2 relative pl-0 sm:pl-1 lg:pl-2 mt-4 sm:mt-0">
                <InputField
                  type="text"
                  name="companyName"
                  placeholder="Company Name"
                  {...register("companyName", {
                    required: "Company Name is required",
                  })}
                  onChange={(value) => setValue("companyName", value)}
                  icon={Icons.companyName}
                  iconStyle="w-5 h-5 sm:w-5 sm:h-5 lg:h-6 lg:w-7 2xl:w-8 2xl:h-7"
                />
                {errors.companyName && (
                  <span style={{ color: "red" }}>
                    {errors.companyName.message}
                  </span>
                )}
              </div>
            </>
          )}
        </div>
        {/* <div className="relative mt-2.5 2xl:mt-5">
                            <CustomDropdown
                                label="Select Pricing"
                                value={getValues("pricing")} // Get the current value, which includes the default
                                options={pricingOptions}
                                isOpen={isPricingDropdownOpen}
                                toggleDropdown={pricingToggleDropdown}
                                handleSelect={handlePricingSelect}
                                leftIcon={Icons.pricingIcon}
                                rightIcon={Icons.dropDwonicons}
                                {...register("pricing", { required: "Price is required" })}
                            />
                            {errors.pricing && <span style={{ color: 'red' }}>{errors.pricing.message}</span>}
                        </div> */}
        <div>
          <div className="flex justify-start items-center mt-5">
            <label className="custom-radio cursor-pointer w-9 flex justify-center items-center md:text-[17px] text-[18px] 2xl:text-[20px] font-raleway">
              <input
                type="checkbox"
                {...register("termsAndConditions", {
                  required: "You must agree to the terms and conditions",
                })}
                className="hidden peer"
              />
              <span className="w-8 h-8 inline-block border-4 border-primary rounded-lg peer-checked:bg-primary peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-6"></span>
            </label>
            <Text
              text={
                <>
                  Agree on{" "}
                  <Text
                    text={"Terms And Conditions"}
                    color="text-primary hover:text-[#707070]"
                    onClick={handleContinueClick}
                    className={
                      "underline cursor-pointer transition duration-300 ease-in-out inline"
                    }
                  />
                </>
              }
              size={fontSizes.h19}
              weight={TextWeight.Raleway_SemiBold}
              color="text-black"
              isCenter={true}
              isTruncate={false}
              className={"inline mt-2 sm:mt-3 ml-2 mb-1"}
            />
          </div>
          {errors.termsAndConditions && (
            <span style={{ color: "red" }}>
              {errors.termsAndConditions.message}
            </span>
          )}
        </div>
        <Btn
          type={"submit"}
          isDisabled={loadingToapi}
          loading={loadingToapi}
          isprimary={false}
          weight={TextWeight.Raleway_SemiBold}
          textSize={fontSizes.h18}
          text={"Sign Up"}
          color="text-white"
          hover={"hover:text-primary hover:bg-white hover:border-primary"}
          bgColor={"bg-primary border-transparent"}
          className={"mt-4 mx-auto"}
        />
      </form>
      <div className="flex justify-center items-center">
        <Text
          text={
            <>
              Already have an account?{" "}
              <Text
                text={"Sign In"}
                color="hover:text-primary"
                onClick={() => navigate("/login")}
                className={
                  "underline cursor-pointer transition duration-300 ease-in-out inline"
                }
              />
            </>
          }
          size={fontSizes.h18}
          weight={TextWeight.Raleway_SemiBold}
          color="text-black"
          isCenter={true}
          isTruncate={false}
          className={"inline mt-2 sm:mt-3"}
        />
      </div>
      {showPopup && (
        <div className="fixed inset-0 backdrop-blur-md px-8 sm:px-24 bg-[#707070] bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-secondary rounded-[50px] p-5 text-center w-full sm:w-full md:w-[60%] lg:w-[70%]  max-h-[90vh] overflow-y-auto hide-scrollbar">
            <div className="flex justify-end">
              <AiOutlineClose
                onClick={closePopup}
                className="text-[28px] cursor-pointer"
              />
            </div>
            <FormHeading
              title="Terms &"
              highlightText={"Conditions"}
              secondDescription1={
                "By signing up or using the service, the user agrees to comply with the terms and conditions mentioned below"
              }
              secondDescription2={
                "Users need to provide accurate and complete information during sign-up"
              }
              secondDescription3={
                "The service provider may collect, store, and use personal information in accordance with their Privacy Policy"
              }
              secondDescription4={
                "Users may not engage in illegal activities, spam, fraud, or any other activity that could harm the platform, its users, or third parties."
              }
              secondDescription5={
                "The service provider can suspend or terminate a user's account for violations of the terms or other reasons"
              }
            />
          </div>
        </div>
      )}
    </AuthLayout>
  );
}
